import React, { useEffect, useState } from 'react';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import {
  DragDropPrioritization,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/components/DragDropPrioritization/DragDropPrioritization';
import { GoalItemLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/GoalItemLayout';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export function GoalPrioritizationLayout() {
  const { resource, onSubmit: onSubmitMetaForm } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { onClickNext } = useSurveyStepContext();
  const [goals, setGoals] = useState(resource?.attr('goals')?.resources()?.list() || []);

  useEffect(() => {
    setGoals(resource?.attr('goals')?.resources()?.list() || []);
  }, [resource.instanceId()]);

  const handleChange = (newGoals) => {
    resource.attr('goals').resources().removeAllItems();
    resource.attr('goals').resources().pushItems(newGoals);
    setGoals(newGoals);
  };

  const handleSubmit = async () => {
    try {
      await onClickNext(onSubmitMetaForm);
    } catch (e) {
      displayErrorMessage(e, e.errors || 'Unable to save. If the issue persists please contact your planner.');
    }
  };

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'} width={'100%'}>
      <FDStack direction={'column'} spacing={2} alignItems={'center'} width={'100%'} maxWidth={425}>
        <MetaControlField attr={'title'} simpleRootStyle />
        <MetaControlField attr={'subtitle'} simpleRootStyle />
      </FDStack>
      <FDStack direction={'column'} spacing={6} alignItems={'center'} width={'100%'}>
        <DragDropPrioritization dropZoneId={'goals'} items={goals} ItemComponent={GoalItemLayout} onChange={handleChange} />
      </FDStack>
      <SurveyStepFooter onSubmit={handleSubmit} />
    </FDStack>
  );
}
